export default __webpack_public_path__ + "static/media/Ring of Ancient Python.75d42a68.jpg";